<template>
  <v-row
    no-gutters
    class="flex-column align-center align-xl-stretch justify-space-between dashboard-navigation"
  >
    <div class="mt-10 ml-xl-8" data-cy="clientZoneDashboardLogo">
      <Logo link="dashboard" class="show-on-desktop" />
      <Logo link="dashboard" class="show-on-tablet" mobile />
    </div>
    <v-list
      class="pt-0 pt-xl-15 px-0 align-self-stretch"
      data-cy="clientZoneDashboardProfileNavigation"
    >
      <v-list-item
        v-for="(item, index) in links"
        :key="index"
        link
        :to="!!item.location ? $localePath(item.location) : undefined"
        class="py-4 px-6 mb-4 menuItem justify-center"
        :data-cy="item.data_cy"
        :class="{
          'item-selected': item.location === currentPath
        }"
        :ripple="false"
        exact
        @click="gtmPush({ event: 'menu_click', 'menu.detail': item.title })"
      >
        <v-list-item-icon class="mr-0 mr-xl-4 my-0">
          <v-img width="32" eager contain height="32" :src="$asset(`img/icons/${item.icon}.svg`)" />
        </v-list-item-icon>
        <v-list-item-content v-if="$vuetify.breakpoint.xlOnly" class="d-none d-xl-flex">
          {{ item.title }}
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <div class="d-block d-xxl-none">
      <v-list class="pt-0 px-0 align-self-stretch mb-11">
        <v-list-item
          class="py-4 px-6 mb-4 menuItem justify-center profile_picture_holder"
          :ripple="false"
          exact
          @click="
            setDialog({
              name: 'profileMobile',
              params: {
                //keep empty params here for dialogParams functionality
                type: '',
                stepProfile: '',
                documentName: ''
              }
            })
          "
        >
          <v-list-item-icon class="mr-0 mr-xl-4 my-0">
            <ProfilePicture :size="$vuetify.breakpoint.xlOnly ? 24 : 48" />
          </v-list-item-icon>
          <v-list-item-content v-if="$vuetify.breakpoint.xlOnly" class="d-none d-xl-flex">
            {{ $t('profileSection.menu.profile') }}
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </div>
  </v-row>
</template>

<script>
import profileNavigation from '@/mixins/profileNavigation';
import { mapMutations } from 'vuex';
import Logo from '@/components/Atoms/Logo';
import ProfilePicture from '@/components/Atoms/ProfilePicture';

export default {
  name: 'ProfileNavigation',
  components: { ProfilePicture, Logo },
  mixins: [profileNavigation],
  methods: {
    ...mapMutations({
      setDialog: 'profile/dashboard/setDialog'
    })
  }
};
</script>

<style lang="scss" scoped>
.dashboard-navigation {
  @media #{map-get($display-breakpoints, 'xl-and-down')} {
    height: 100%;
  }
  @media #{map-get($display-breakpoints, 'xxl-only')} {
    justify-content: start !important;
    align-items: stretch !important;
  }
}

.v-list-item {
  z-index: 2;
  border-left: 3px solid transparent;

  &:hover,
  &:focus,
  &:active {
    text-decoration: none !important;

    &:before {
      opacity: 1 !important;
      z-index: 3;
    }
  }

  &.profile_picture_holder:before {
    @media #{map-get($display-breakpoints, 'lg-and-down')} {
      opacity: 0 !important;
    }
  }

  @media only screen and (min-width: 1440px) {
    border-right: 3px solid transparent;
    border-left: none;
  }

  &__icon {
    z-index: 4;
    @media #{map-get($display-breakpoints, 'lg-only')} {
      margin-left: -3px;
    }
  }

  &__content {
    z-index: 4;
  }

  &.item-selected {
    background-image: linear-gradient(to right, rgba(3, 167, 186, 0.08), rgba(196, 196, 196, 0));
    border-color: $primary;

    @media only screen and (min-width: 1440px) {
      background-image: linear-gradient(to left, rgba(3, 167, 186, 0.08), rgba(196, 196, 196, 0));
    }

    .v-list-item__content {
      font-weight: $font-weight-bold !important;
    }

    &::before {
      opacity: 0 !important;
    }
  }

  &--link:before {
    margin-left: 8px;
    margin-right: 12px;
    border-radius: 12px !important;
    background-color: $grey-lighten-1;
  }
}

a.menuItem {
  font-weight: $font-weight-normal !important;
  color: $black !important;
}

.show-on-desktop {
  display: block;

  @media only screen and (max-width: 1199px) {
    display: none;
  }
}

.show-on-tablet {
  display: none;

  @media only screen and (max-width: 1199px) {
    display: block;
  }
}
</style>
